import React from 'react';
import './main.scss';
import logo from '../assets/images/TFP-logo-header-red.png';
const marked = require('marked');

export default ({ data, hasLowerPadding = true }) =>
    <div className={`main ${hasLowerPadding ? 'main__with-lower-padding' : ''}`}>
        <div className="main__content">
            <div className="main__content__copy">
                <h3 className="main__content__headline">
                    {data.mainHeading}
                </h3>
                <img className="main__logo" src={logo} />
                <div
                    className="main__content__copy__inner"
                    dangerouslySetInnerHTML={{
                        __html: marked(data.mainText.mainText, {
                            gfm: true,
                            breaks: true,
                        }),
                    }}
                />
                {!!data.callToActionText &&
                    !!data.callToActionUrl &&
                    <div className="collaborations__link">
                        <a href={data.callToActionUrl} target="_blank">
                            {data.callToActionText}
                            <i className="fas fa-chevron-right" />
                        </a>
                    </div>}
            </div>
            <div className="main__content__image">
                <div className="main__content__image__expander">
                    {data.imageLinkUrl && data.imageLinkUrl !== 'NONE'
                        ? <a href={data.imageLinkUrl} target="_blank">
                              <img src={data.mainVideoUrl} />
                          </a>
                        : <iframe src={data.mainVideoUrl} scrolling="no" frameBorder="0" allowFullScreen="true" />}
                </div>
            </div>
        </div>
    </div>;



// WEBPACK FOOTER //
// ./src/components/main.js